import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { Crud, CrudService, ConfigServerService, CustomHttp } from '../../../core';
import { TabelaPreco } from '../tabela-preco';
import { TabelaPrecoSearchAsync } from '../tabela-preco-search';
import { TabelaPrecoFilterSearch } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class TabelaPrecoCrudHttpService implements Crud<TabelaPreco> {
    resource = 'tabelapreco';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as tabelas de preços cadastradas */
    search(): Observable<TabelaPreco[]> {
        return this.crudService.search<TabelaPreco>(this.resource);
    }

    searchWithFilter(filter: TabelaPrecoFilterSearch, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<TabelaPrecoSearchAsync> {
        // Params
        let params = new HttpParams()
                            .append('drawDatatable', drawDatatable ? drawDatatable.toString() : null)
                            .append('offset', offset ? offset.toString() : null)
                            .append('limit', limit ? limit.toString() : null)
                            .append('orderBy', orderBy ? orderBy.toString() : null)
                            .append('orderByDir', orderByDir ? orderByDir : '');
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<TabelaPrecoSearchAsync>(this.pathApi, {params});
    }

    /** Procura uma única tabela de preço através do seu ID */
    find(id: number): Observable<TabelaPreco> {
        return this.crudService.find<TabelaPreco>(this.resource, id);
    }

    /** Carrega uma única tabela de preço através do seu ID */
    load(id: number): Observable<TabelaPreco> {
        return this.crudService.load<TabelaPreco>(this.resource, id);
    }

    /** Insere uma nova tabela de preço */
    insert(entity: TabelaPreco): Observable<TabelaPreco> {
        return this.crudService.insert<TabelaPreco>(this.resource, entity);
    }

    /** Altera uma tabela de preço existente */
    update(entity: TabelaPreco): Observable<TabelaPreco> {
        return this.crudService.update<TabelaPreco>(this.resource, entity);
    }

    /** Exclui uma tabela de preço através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
